import ReactDOM from "react-dom";
import React from "react";
import {App} from "./components/app-original";

const app = document.querySelector("#app");
ReactDOM.render(<App />, app);
